export default {
  drawer: null,
  color: 'primary',
  image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-3.3a54f533.jpg',
  snackbar: false,
  snackbarColor: 'primary',
  message: '',
  top: true,
  bottom: false,
  left: false,
  right: false,
  dialog: false,
  dialogTitle: '',
  dialogMessage: '',
  dialogColor: 'error',
}
